import React from 'react';

const Leads = ({ userId }) => {
    return (
        <div className="text-muted text-center py-5">
            <h6>Leads</h6>
            <p className="small mb-0">Broker CRM Leads will appear here.</p>
        </div>
    );
};

export default Leads;
